import React from 'react';
import { Link } from 'react-router-dom';
import './TermsOfServicePage.scss'

const TermsOfServicePage: React.FC = () => {
  return (
    <div className="terms-of-service-page">
    <h1>Terms of Service</h1>
    <p>Last updated: September, 8, 2024</p>
  
    <section>
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using Kitchen9's services, including our website, mobile
        application, and AI-powered recipe generation tools (collectively, the
        "Service"), you agree to comply with and be bound by these Terms of
        Service ("Terms"). If you disagree with any part of the Terms, you may
        not access or use the Service.
      </p>
    </section>
  
    <section>
      <h2>2. Description of Service</h2>
      <p>
        Kitchen9 provides an AI-powered platform for recipe generation, sharing,
        and customization. Our Service includes features such as meal planning,
        grocery list creation, and community interaction around cooking and
        recipes. The Service is available to users worldwide, subject to these
        Terms and applicable laws in your jurisdiction.
      </p>
    </section>
  
    <section>
      <h2>3. User Accounts</h2>
      <p>
        To access certain features of the Service, you may be required to register
        for an account. You agree to provide accurate, current, and complete
        information during the registration process and to update such information
        as necessary. You are responsible for safeguarding your account and any
        activities or actions taken under your account credentials.
      </p>
      <p>
        You agree not to disclose your password to any third party. You must
        notify us immediately if you suspect any unauthorized access to your
        account.
      </p>
    </section>
  
    <section>
      <h2>4. User-Generated Content</h2>
      <p>
        The Service allows you to post, link, store, share, and make available
        various types of content, including but not limited to text, graphics,
        videos, or other material ("Content"). You retain ownership of any
        Content you submit, post, or display on or through the Service.
      </p>
      <p>
        By posting Content, you grant Kitchen9 a worldwide, non-exclusive,
        royalty-free license to use, reproduce, modify, adapt, publicly perform,
        publicly display, distribute, and create derivative works from such
        Content solely for the purpose of providing and promoting the Service.
      </p>
    </section>
  
    <section>
      <h2>5. Intellectual Property Rights</h2>
      <p>
        The Service and all original content, features, and functionality
        (excluding Content provided by users) are and will remain the exclusive
        property of Kitchen9 and its licensors. The Service is protected by
        international copyright, trademark, and other intellectual property laws.
      </p>
      <p>
        Our trademarks and trade dress may not be used in connection with any
        product or service without our prior written consent.
      </p>
    </section>
  
    <section>
      <h2>6. AI-Generated Content</h2>
      <p>
        The AI-generated recipes and content provided through the Service are
        meant for informational purposes only. Kitchen9 does not guarantee the
        accuracy, reliability, or safety of any AI-generated content. You should
        exercise your own discretion when using these recipes, especially if you
        have dietary restrictions, allergies, or medical conditions.
      </p>
    </section>
  
    <section>
      <h2>7. Prohibited Activities</h2>
      <p>
        You agree not to use the Service for any unlawful purposes or to engage in
        any activities that infringe on the rights of others. This includes, but
        is not limited to, unauthorized commercial exploitation, distributing
        harmful software, or engaging in any activity that disrupts the Service or
        infringes upon the intellectual property rights of others.
      </p>
    </section>
  
    <section>
      <h2>8. Termination</h2>
      <p>
        Kitchen9 may suspend or terminate your access to the Service at any time
        without prior notice or liability if you breach these Terms or engage in
        any prohibited activities. Upon termination, all provisions of the Terms
        that should reasonably survive termination shall continue to apply.
      </p>
    </section>
  
    <section>
      <h2>9. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, Kitchen9, its directors,
        employees, partners, agents, suppliers, or affiliates shall not be liable
        for any indirect, incidental, special, consequential, or punitive
        damages, including, but not limited to, loss of profits, data, use,
        goodwill, or other intangible losses resulting from your use of the
        Service.
      </p>
    </section>
  
    <section>
      <h2>10. Governing Law</h2>
      <p>
        These Terms shall be governed and construed in accordance with the laws of
        the jurisdiction in which Kitchen9 operates, without regard to conflict of
        law principles. Additionally, users in other countries agree to abide by
        their respective local laws while using the Service.
      </p>
    </section>
  
    <section>
      <h2>11. Changes to Terms</h2>
      <p>
        Kitchen9 reserves the right, at its sole discretion, to modify or replace
        these Terms at any time. You will be notified of any material changes, and
        your continued use of the Service after such changes constitutes your
        acceptance of the revised Terms.
      </p>
    </section>
  
    <section>
      <h2>12. Contact Us</h2>
      <p>
        If you have any questions regarding these Terms, please{" "}
        <Link to="/contact">contact us</Link>.
      </p>
    </section>
  </div>
  
  );
};

export default TermsOfServicePage;